import { render, staticRenderFns } from "./registrationOrder.vue?vue&type=template&id=a26e8074&scoped=true"
import script from "./registrationOrder.vue?vue&type=script&lang=js"
export * from "./registrationOrder.vue?vue&type=script&lang=js"
import style0 from "./registrationOrder.vue?vue&type=style&index=0&id=a26e8074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26e8074",
  null
  
)

export default component.exports